import type { ApprovalDecision } from '@salescore/agent-contract'
import { createContext, useContext } from 'react'

import type { SessionChat } from '../domain/sessionChat'

// ウィジェットの状態を、部分ごとの context で部品に渡す（仕様の「状態の管理」）。
// 回答が伸びたときに描き直されるのを、会話を読む部品だけにするため、会話、実行中のターン、停止中、送れるかを別の context にする。
// 値は AgentWidget が useAgentChat の状態から作る

// 開いているチャットの会話。まだ指示を送っていなければ undefined
export const AgentChatContext = createContext<SessionChat | undefined>(undefined)

// 開いているチャットの実行中のターン。実行中でなければ null
export const AgentRunningTurnContext = createContext<string | null>(null)

// 開いているチャットで、停止を押してターンの終わりを待っているか。停止のボタンを「停止中」にする
export const AgentTurnStoppingContext = createContext(false)

// 開いているチャットに今指示を送れるか（selectCanSendToOpenChat を描いた状態に当てた値）。送信のボタンと Enter に使う
export const AgentCanSendContext = createContext(true)

// 指示の送信と停止の操作。描き直しても同じ関数を渡す
export interface AgentChatActions {
  // 送ったかを返す。実行中は送らない（ADR-107）。描いた状態より先に進んだ ref で確かめるので、部品が送れると判断しても断ることがある
  sendPrompt: (prompt: string) => boolean
  // 停止のボタン
  stopTurn: () => void
  startNewChat: () => void
  // 承認のカードの許可と拒否。送っている間と答えた後の承認には送らない。受け付けられなかったとき（期限切れなど）と失敗は、理由を出す
  answerApproval: (turnId: string, approvalId: string, decision: ApprovalDecision) => void
}

export const AgentChatActionsContext = createContext<AgentChatActions | null>(null)

/**
 * 指示の送信と停止の操作を返す。AgentWidget の中の部品で使う。
 */
export const useAgentChatActions = (): AgentChatActions => {
  const actions = useContext(AgentChatActionsContext)
  if (actions === null) {
    throw new Error('useAgentChatActions は AgentWidget の中の部品で使う')
  }
  return actions
}
